import axios from "axios";
// 核对邀请链接
export const validInviteLink = params => {
  return axios.request({
    url: "/api/inviteLink/validInviteLink",
    method: "get",
    params
  });
};
// 发送验证码
export const sendVerificationCode = params => {
  return axios.request({
    url: "/api/inviteLink/sendVerificationCode",
    method: "get",
    params
  });
};
// 消费邀请链接
export const consumeInviteLink = data => {
  return axios.request({
    url: "/api/inviteLink/consumeInviteLink",
    method: "post",
    data
  });
};
export default {
  validInviteLink,
  sendVerificationCode,
  consumeInviteLink
};